import { render, staticRenderFns } from "./marker-order-dishes.vue?vue&type=template&id=6c6c7d72&scoped=true&"
import script from "./marker-order-dishes.js?vue&type=script&lang=js&"
export * from "./marker-order-dishes.js?vue&type=script&lang=js&"
import style0 from "./marker-order-dishes.scss?vue&type=style&index=0&id=6c6c7d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c7d72",
  null
  
)

export default component.exports